module.exports = "/static/assets/babaffcbf18924e42abcd841cfe05724.png";